// src/MyComponent.js

import React, { Component } from 'react';
import { Logo } from '../Navbar/Navbar'
 import './About.css'


export class About extends Component {
    render() {
        return (


            <div class="center-container">

        <div class="card cardp">

 
  <div className="about-container">
            <h1>Who We Are ?</h1>
            <p>
               <span >LAST</span>  is a <strong>Indian based startup company</strong> with expertise in 
                <strong> document tracking and management solutions</strong>. We specialize in building 
                <strong> custom software</strong> tailored to business needs, ensuring efficient 
                document handling, retrieval automation, and secure management.
            </p>
            <p>
                Our team is skilled in <strong>Django, React, Angular, SQL,PostgreSQL, and AI</strong>, 
                delivering innovative and scalable solutions.
            </p>

  </div>
  
  
 
  
</div>
              












              
            </div>



        )
    }
}
